import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';
import Cookies from 'js-cookie';

import translationEng from './locales/en/translation';
import translationId from './locales/id/translation';
import translationRu from './locales/ru/translation';
import translationUz from './locales/uz/translation';
import translationVn from './locales/vn/translation';
import industriesEng from './locales/en/industries.json';
import industriesId from './locales/id/industries.json';
import industriesRu from './locales/ru/industries.json';
import industriesUz from './locales/uz/industries.json';
import industriesVn from './locales/vn/industries.json';
import convergenceEng from './locales/en/convergence';
import convergenceId from './locales/id/convergence';
import convergenceRu from './locales/ru/convergence';
import convergenceUz from './locales/uz/convergence';
import convergenceVn from './locales/vn/convergence';

import uncdfEng from './locales/en/uncdf.json';
import uncdfId from './locales/id/uncdf.json';

const keyIso = 'languageISOCode';

i18n.use(XHR)
    .use(LanguageDetector)
    .init({
        debug: false,
        lng: Cookies.get(keyIso) || 'en',
        fallbackLng: 'en', // use en if detected lng is not available
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        resources: {
            en: {
                translations: translationEng,
                industries: industriesEng,
                uncdf: uncdfEng,
                convergence: convergenceEng,
            },
            id: {
                translations: translationId,
                industries: industriesId,
                uncdf: uncdfId,
                convergence: convergenceId,
            },
            ru: {
                translations: translationRu,
                industries: industriesRu,
                uncdf: uncdfEng,
                convergence: convergenceRu,
            },
            uz: {
                translations: translationUz,
                industries: industriesUz,
                uncdf: uncdfEng,
                convergence: convergenceUz,
            },
            vn: {
                translations: translationVn,
                industries: industriesVn,
                uncdf: uncdfEng,
                convergence: convergenceVn,
            },
        },
        // have a common namespace used around the full app
        ns: ['translations'],
        defaultNS: 'translations',
    });

export default i18n;
